import * as React from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './chat-onboarding-layout.module.css';

type Props = {
    title: string;
    subtitle: string | React.ReactNode;
    animation: React.ReactNode;
    actionComponent?: React.ReactNode;
    errorMessage?: string;
};

export function ChatOnboardingLayout(props: Props) {
    return (
        <div className={styles['content-container']}>
            <Stack spacing={24} alignItems='center' justifyContent='center'>
                <div className={styles['animation-container']}>{props.animation}</div>
                {/* @ts-expect-error */}
                <Stack spacing={12} alignItems='center' color='dark'>
                    <Body size='xlarge' isBold={true} useDoyle={true}>
                        {props.title}
                    </Body>
                    <Body size='large' textAlign='center'>
                        {props.subtitle}
                    </Body>
                    <div className={styles['action-container']}>{props.actionComponent}</div>
                    {props.errorMessage && (
                        <Body size='small' color='error'>
                            {props.errorMessage}
                        </Body>
                    )}
                </Stack>
            </Stack>
        </div>
    );
}
